import { observable, runInAction } from 'mobx'

const GlobalState = observable({
  isMenuOpen: false,
  isLocaleOpen: false,
  domain: '',
  currentLocale: {
    country: 'Ukraine',
    lang: 'English',
  },
})

export default GlobalState

export const changeMenuState = () => {
  runInAction(() => {
    GlobalState.isMenuOpen = !GlobalState.isMenuOpen
  })
}
export const changeLocaleState = () => {
  if (GlobalState.isMenuOpen) {
    runInAction(() => {
      GlobalState.isMenuOpen = !GlobalState.isMenuOpen
    })
  }
  runInAction(() => {
    GlobalState.isLocaleOpen = !GlobalState.isLocaleOpen
  })
}

export const setLang = () => {
  if (localStorage.getItem('lang')) {
    const lang = JSON.parse(localStorage.getItem('lang')!)
    runInAction(() => {
      GlobalState.currentLocale = lang
    })
  } else {
    localStorage.setItem(
      'lang',
      JSON.stringify({
        country: GlobalState.currentLocale.country,
        lang: GlobalState.currentLocale.lang,
      }),
    )
  }
}

export const changeLocale = (lang: string, country: string) => {
  localStorage.setItem(
    'lang',
    JSON.stringify({
      country: country,
      lang: lang,
    }),
  )

  let path = ''
  if (country.includes('Ukr')) {
    if (lang.includes('En')) {
      path = '/en' + window.location.pathname
    } else {
      path = window.location.href
        .replaceAll('/uk', '')
        .replaceAll('/en', '')
        .replaceAll('/ru', '')
    }
  }
  window.location.href = path
}
